<div class="empty-container" *ngIf="json.length === 0">
  <h3>{{ emptyMessage }}</h3>
</div>
<div [@.disabled]="!animate" *ngIf="json.length > 0" class="json-container">
  <div
    [@slideInAnimation]
    [@greenInAnimation]
    *ngFor="let obj of json"
    class="json"
  >
    <ngx-json-viewer [depth]="1" [json]="obj"></ngx-json-viewer>
  </div>
</div>
